<template>


  <div class="hello">
    <h1>{{ msg }}</h1>
    
<div class="div_box">
    <p>
      You need to connect your wallet to staking your coins.
    </p>
    <br>

    <p>
    <input size="100"  placeholder="User Address" type="text" name="userAddress" class="form__input" v-model="userAddress" readonly/>
    </p>
    
    <p>
      <label for="name" class="form__label">$ERFC Balance</label>
    </p>

    <p>
      <br>
    <input size="100"  placeholder="$ERFC balance" type="text" name="erfcBalance" class="form__input_text_big" v-model="erfcBalance" readonly/>
    </p>


  </div>
  </div>

  <div class="div_box">
   
    <table class="table">
         

  <tr>              <td>Enter the amount of coins you want to staking, the minimum is 500k</td></tr>          
  <tr>              <td>Lockout period 120 days.</td></tr>          
  <br>
      <tr>

              <td >
                  <input  class="form__input_text_big_2"  type="number" id="quantity" name="quantity" min="500000" max="1000000000000000000000000000000000" v-model="quantity" >
                  <br>
                  <button class="button-85" id="addStake" @click="getAllowance"> Staking </button>
              </td>

            </tr>
     </table>



    <br>

  </div>

  <div class="div_box">
          <table id="stakeTable" class="table">
              <th>Amount</th>
              <th>Date</th>
              <th>Withdraw available?</th>
              <th>                   </th>
          </table>
    

        </div>
        <br><br>
  <button class="button-85" id="removeStake" @click="removeStaking"> Remove selected staking </button>

        <br><br><br><br><br><br><br><br>
</template>

<script>
import { ethers } from "ethers";
//import $ from 'jquery';

export default {
  name: 'UserWallet',
  props: {
    msg: String
  }, data() {
      return {
        userAddress: '',
        erfcBalance: '',
        quantity: '',

      }
    },methods: {
           
         getBalance(_address){
          console.log("Received: "+ _address) 
          _address = _address +""
          var address = ethers.utils.getAddress(_address)
          this.userAddress = ethers.utils.getAddress(_address)
          window.ethereum.request({
            method:'eth_getBalance', 
            params: [address, 'latest']
          }).then(balance => {
            // Return string value to convert it into int balance
            console.log(balance) 
              
            // Yarn add ethers for using ethers utils or
            // npm install ethers
            //console.log(window.ethereum.utils.formatEther(balance))
            console.log("Amount Ether: " + ethers.utils.formatEther(balance))

            //contracts(address)
            // Format the string into main latest balance
          })
        }, getTokenBalance(){
              const ethers = require('ethers')

              
              // The Contract interface
              let abi = [
                "function totalSupply() external view returns (uint256)",
                "function balanceOf(address account) external view returns (uint256)",
                "function allowance(address owner, address spender) external view returns (uint256)",
                "function transfer(address recipient, uint256 amount) external returns (bool)",
                "function approve(address spender, uint256 amount) external returns (bool)",
                "function transferFrom(address sender, address recipient, uint256 amount) external returns (bool)",
                "event Transfer(address indexed from, address indexed to, uint256 value)",
                "event Approval(address indexed owner, address indexed spender, uint256 value)"
              ]

              // Connect to the network
              //let provider = ethers.getDefaultProvider()
             // let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc_testnet_chapel") // testnet
                let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc") // production

              // The address from the above deployment example
              let contractAddress = "0xBe055654011E1FD1CC141F96Bb2edAe4930dCa28" // production
              //let contractAddress = "0xC3672F25C5dA3ac3E752d0A9804BA7495A99Deba" // testnet

              // We connect to the Contract using a Provider, so we will only
              // have read-only access to the Contract
              let contract = new ethers.Contract(contractAddress, abi, provider)

    
                
            
            contract.balanceOf(""+this.userAddress).then(balance => {
                  // Return string value to convert it into int balance
                  console.log("$ERFC balance: " + ethers.utils.formatEther(balance)) ;
                  this.erfcBalance = ethers.utils.formatEther(balance);
                  
                })

          }, getStakedBI(index){
              const ethers = require('ethers')

              
              // The Contract interface
              let abi = [{
                            "inputs": [
                              {
                                "internalType": "uint256",
                                "name": "_index",
                                "type": "uint256"
                              }
                            ],
                            "name": "getStakByIndex",
                            "outputs": [
                              {
                                "internalType": "uint256",
                                "name": "_amount",
                                "type": "uint256"
                              },
                              {
                                "internalType": "uint256",
                                "name": "_date",
                                "type": "uint256"
                              },
                              {
                                "internalType": "bool",
                                "name": "_ReadyToWithdraw",
                                "type": "bool"
                              },
                              {
                                "internalType": "bool",
                                "name": "_Staked",
                                "type": "bool"
                              }
                            ],
                            "stateMutability": "view",
                            "type": "function"
                          }]


             // let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc_testnet_chapel") // testnet
              let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc") // production

               //The address from the above deployment example
              let contractAddress = "0x45C5bE647F1f55DAe10c0a06cB658F41f8DCD5b6" // Staking contract address production
             // let contractAddress = "0xE2a288A6825C3AF7aeb9802f53fF283168F429Bb";// Staking contract address  testnet
              

              // We connect to the Contract using a Provider, so we will only
              // have read-only access to the Contract
              let contract = new ethers.Contract(contractAddress, abi, provider)
              
              var table = document.getElementById("stakeTable");
              var sizeTable = table.rows.length;
                    
              for (var i = 0; i < sizeTable-1 ; i++) {
                table.deleteRow(1);
              }

    
        
              // return _amount,_date,_ReadyToWithdraw,_Staked);

            contract.connect(this.userAddress+'').getStakByIndex(index).then(balance => {
                  // Return string value to convert it into int balance
                  console.log("Index " + index);
                  console.log("$ERFC Staked balance: json " + JSON.stringify(  balance ));

                  var amount = ethers.utils.formatEther(balance[0]);

                  var convertdate = new Date(balance[1] * 1000);
                  console.log("convertdate " + convertdate);

                  var staked = balance[3];
                  var readyToWithdraw  = staked &&  balance[2] ;

                  console.log("_ReadyToWithdraw: " + balance[2]) ;
                  console.log("_Staked: " + balance[3]) ;


                  var row = table.insertRow(table.rows.length);
                  var cell1 = row.insertCell(0);
                  var cell2 = row.insertCell(1);
                  var cell3 = row.insertCell(2);
                  var cell4 = row.insertCell(3);

                  cell1.innerHTML = amount;
                  cell2.innerHTML = convertdate;
                  //cell3.innerHTML = readyToWithdraw;
                  if (readyToWithdraw){
                    cell3.innerHTML = '&#10004;';
                  }

                  if (amount == 0){
                    readyToWithdraw = false;
                  }

                  var x = document.createElement("INPUT");
                  x.name="choose";
                  x.setAttribute("type", "radio");
                  x.checked = false;
                  x.id = index;
                 
                  if (staked && readyToWithdraw){
                    x.disabled = false;  

                  }else{
                    x.disabled = true;
                    x.style="display:none";
                  }
                  if( !staked){
                    cell3.innerHTML = 'Claimed';
                  }
                  cell4.append(x);
                  
                  
                })

          }, getTotalStaked(){
              const ethers = require('ethers')

              
              // The Contract interface
              let abi = [{
                        "inputs": [
                          {
                            "internalType": "address",
                            "name": "_address",
                            "type": "address"
                          }
                        ],
                        "name": "getTotalStaked",
                        "outputs": [
                          {
                            "internalType": "uint256",
                            "name": "count",
                            "type": "uint256"
                          }
                        ],
                        "stateMutability": "view",
                        "type": "function"
                      }]


              //let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc_testnet_chapel") // testnet
              let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc") // production

              // The address from the above deployment example
              let contractAddress = "0x45C5bE647F1f55DAe10c0a06cB658F41f8DCD5b6" // Staking contract address production
              //let contractAddress = "0xE2a288A6825C3AF7aeb9802f53fF283168F429Bb" // Staking contract address testner

              

              // We connect to the Contract using a Provider, so we will only
              // have read-only access to the Contract
              let contract = new ethers.Contract(contractAddress, abi, provider)

    
        
            
            contract.connect(this.userAddress+'').getTotalStaked(this.userAddress).then(balance => {
                  // Return string value to convert it into int balance
                  console.log("$ERFC Staked balance: json " + JSON.stringify(  balance ));
                  console.log("$ERFC Staked balance: " + ethers.utils.formatEther(balance)) ;
                  //this.erfcBalance = ethers.utils.formatEther(balance);
                  
                })

          }
          , getStakeds(){
              const ethers = require('ethers')

              var intRet = 0;
              // The Contract interface
              let abi = [{
                          "inputs": [],
                          "name": "getStakSize",
                          "outputs": [
                            {
                              "internalType": "uint256",
                              "name": "_count",
                              "type": "uint256"
                            }
                          ],
                          "stateMutability": "view",
                          "type": "function"
                        }]


             // let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc_testnet_chapel") // testnet
              let provider = ethers.getDefaultProvider("https://rpc.ankr.com/bsc") // production

              // The address from the above deployment example
               let contractAddress = "0x45C5bE647F1f55DAe10c0a06cB658F41f8DCD5b6" // Staking contract address production
              //let contractAddress = "0xE2a288A6825C3AF7aeb9802f53fF283168F429Bb" // Staking contract address testnet
              

              // We connect to the Contract using a Provider, so we will only
              // have read-only access to the Contract
              let contract = new ethers.Contract(contractAddress, abi, provider)

    
              contract.connect(this.userAddress+'').getStakSize().then(balance => {
                  // Return string value to convert it into int balance
                  //console.log("Staking indexes: json " + JSON.stringify(  balance ));
                  //console.log("Staking indexes : " + ethers.utils.formatEther(balance)) ;
                  console.log("Staking indexes INT: " + balance.toNumber()) ;
                  //this.erfcBalance = ethers.utils.formatEther(balance);
                  intRet = parseInt(balance);
                  console.log("intRet: " + intRet);
                 
                  for (let i = 0; i < intRet; i++){
                    console.log("i: " + i);
                    this.getStakedBI(i);
                  }
                  
                })

          },staking(){
                    
                    let    abi = [{
                                    "inputs": [
                                      {
                                        "internalType": "uint256",
                                        "name": "_amount",
                                        "type": "uint256"
                                      }
                                    ],
                                    "name": "addStake",
                                    "outputs": [
                                      {
                                        "internalType": "bool",
                                        "name": "_ret",
                                        "type": "bool"
                                      }
                                    ],
                                    "stateMutability": "nonpayable",
                                    "type": "function"
                                  }]
      
                          const contractAddress = "0x45C5bE647F1f55DAe10c0a06cB658F41f8DCD5b6"; // stake production
                          //const contractAddress = "0xE2a288A6825C3AF7aeb9802f53fF283168F429Bb"; // stake testnet
                            
                          console.log("Get provider");
                            const provider = new ethers.providers.Web3Provider(window.ethereum)
      
                            console.log("userAddress: " + this.userAddress);
                            const signer = provider.getSigner(this.userAddress+"");
                          // const contractAddress = "0x7D81e7128c51F815f4d7b4C7C17025304C864166";
      
                            console.log("Get contract");
                          
                          // const contract = new ethers.Contract(contractAddress, abi, signer);
                          const contract = new ethers.Contract(contractAddress, abi, provider);
      
                          const daiWithSigner = contract.connect(signer);
                          
                          console.log("User " + this.userAddress + " Qtd  " + ethers.utils.parseEther(this.quantity +'') );
                          
                          daiWithSigner.addStake(ethers.utils.parseEther(this.quantity +'')).then( ret => {
                              // Return string value to convert it into int balance
                              console.log("$Buy ret: " + JSON.stringify(ret) ) ;
      
                              
                              try{
                                console.log(ret.hash);
                                alert('You can see this transaction in BSC Scan by the link below, https://bscscan.com/tx/'+ret.hash+'  ');

                                setTimeout(() => this.getStakeds(), 20000);
                                setTimeout(() => this.getTokenBalance(), 20000);

                                
                                
                              }catch (error){
                                console.log(error);
                                setTimeout(() => this.getStakeds(), 20000);
                                setTimeout(() => this.getTokenBalance(), 20000);
                                
                              }
                           
                              
                            });
                            
          },approve(){
                    
                    //let nftid = 1;
                   // console.log("NFT: " + nftid);
                    let userWallet;
       
                    let    abi = [{
                                    "inputs": [
                                        {
                                            "internalType": "address",
                                            "name": "spender",
                                            "type": "address"
                                        },
                                        {
                                            "internalType": "uint256",
                                            "name": "value",
                                            "type": "uint256"
                                        }
                                    ],
                                    "name": "approve",
                                    "outputs": [
                                        {
                                            "internalType": "bool",
                                            "name": "",
                                            "type": "bool"
                                        }
                                    ],
                                    "stateMutability": "nonpayable",
                                    "type": "function"
                                  }]
    
                        const contractAddress = "0xBe055654011E1FD1CC141F96Bb2edAe4930dCa28"; // ERFC production
                        //const contractAddress = "0xC3672F25C5dA3ac3E752d0A9804BA7495A99Deba"; // ERFC testnet
                        
                        const contractDEXAddress = "0x45C5bE647F1f55DAe10c0a06cB658F41f8DCD5b6" // Staking production
                        //const contractDEXAddress = "0xE2a288A6825C3AF7aeb9802f53fF283168F429Bb" // Staking Testnet
                          
                        console.log("Get provider");
                          const provider = new ethers.providers.Web3Provider(window.ethereum)
    
                          const signer = provider.getSigner(userWallet);
    
                          console.log("Get contract");
                        
                        // const contract = new ethers.Contract(contractAddress, abi, signer);
                        const contract = new ethers.Contract(contractAddress, abi, provider);
    
                        const daiWithSigner = contract.connect(signer);
                        
    
                        daiWithSigner.approve(contractDEXAddress,"10000000000000000000000000000").then( ret => {
                              // Return string value to convert it into int balance
                              console.log("Approve ret: " + JSON.stringify(ret) ) ;
                              
                              setTimeout(() => this.staking(), 20000);

                            try{
                              console.log(ret.transactionHash);
                            }catch (error){
                              console.log(error);
                            }
    
                            
                          })
    
    
               
                          
            },getAllowance(){
                        console.log('Value ' + this.quantity );
                        if( this.quantity < 500000 ){
                          alert('The minimun value to staking is 50000 ERFC');
                          return;
                        }
                        
                        let userWallet;
    
                        const ethers = require('ethers');
    
                            let    abi = [{
                                  "inputs": [
                                      {
                                          "internalType": "address",
                                          "name": "owner",
                                          "type": "address"
                                      },
                                      {
                                          "internalType": "address",
                                          "name": "spender",
                                          "type": "address"
                                      }
                                  ],
                                  "name": "allowance",
                                  "outputs": [
                                      {
                                          "internalType": "uint256",
                                          "name": "",
                                          "type": "uint256"
                                      }
                                  ],
                                  "stateMutability": "view",
                                  "type": "function"
                              }]
    
                        const contractAddress = "0xBe055654011E1FD1CC141F96Bb2edAe4930dCa28"; // ERFC production
                        //const contractAddress = "0xC3672F25C5dA3ac3E752d0A9804BA7495A99Deba"; // ERFC testnet
                        
                      //  const contractDEXAddress = "0xE2a288A6825C3AF7aeb9802f53fF283168F429Bb" // Staking Testnet
                        const contractDEXAddress = "0x45C5bE647F1f55DAe10c0a06cB658F41f8DCD5b6";  // Staking mainnet
                        
                        console.log("Get provider");
                          const provider = new ethers.providers.Web3Provider(window.ethereum)
    
                          const signer = provider.getSigner(userWallet);
    
                          console.log("Get contract");
                        
                        // const contract = new ethers.Contract(contractAddress, abi, signer);
                        const contract = new ethers.Contract(contractAddress, abi, provider);
    
                        const daiWithSigner = contract.connect(signer);
                        
    
                        daiWithSigner.allowance(this.userAddress+"",contractDEXAddress).then( ret => {
                            // Return string value to convert it into int balance
                            console.log("Allowance ret: " + JSON.stringify(ret) ) ;
                            console.log("Allowance ret $: " + ethers.utils.formatEther(ret) );

                            if (ethers.utils.formatEther(ret) > 10000000){
                              this.staking();
                            }else{
                              alert("You need to allow it first!");
                              this.approve();
                            }
    
                            try{
                              console.log(ret.transactionHash);
                            }catch (error){
                              console.log(error);
                            }
    
                            
                          })
    
    
 
                },removeStaking(){

                    var d = document.getElementsByName('choose');   
                    var table = document.getElementById("stakeTable");
                    var _StakeIndex;

                    for (var i = 0; i < d.length ; i++) {
                      console.log("#l: " + i + " v:" + table.rows.item(i).cells.item(0).innerHTML);
                      
                      if (d[i].checked) {          

                         // alert( table.rows.item(i).cells.item(0).innerHTML  );
                          _StakeIndex =  d[i].id ;
                        }
                    }

                    
                    let    abi = [{
                                  "inputs": [
                                    {
                                      "internalType": "uint256",
                                      "name": "_index",
                                      "type": "uint256"
                                    }
                                  ],
                                  "name": "removeStake",
                                  "outputs": [
                                    {
                                      "internalType": "uint256",
                                      "name": "_amountSender",
                                      "type": "uint256"
                                    }
                                  ],
                                  "stateMutability": "nonpayable",
                                  "type": "function"
                                }]
      
                          const contractAddress = "0x45C5bE647F1f55DAe10c0a06cB658F41f8DCD5b6"; // stake production
                         // const contractAddress = "0xE2a288A6825C3AF7aeb9802f53fF283168F429Bb"; // stake testnet
                            
                          console.log("Get provider");
                            const provider = new ethers.providers.Web3Provider(window.ethereum)
      
                            console.log("userAddress: " + this.userAddress);
                            const signer = provider.getSigner(this.userAddress+"");
                          // const contractAddress = "0x7D81e7128c51F815f4d7b4C7C17025304C864166";
      
                            console.log("Get contract");
                          
                          // const contract = new ethers.Contract(contractAddress, abi, signer);
                          const contract = new ethers.Contract(contractAddress, abi, provider);
      
                          const daiWithSigner = contract.connect(signer);
                          
                          console.log("User " + this.userAddress + " Index Staking " + _StakeIndex );
                          
                          daiWithSigner.removeStake( _StakeIndex ).then( ret => {
                              // Return string value to convert it into int balance
                              console.log("$Buy ret: " + JSON.stringify(ret) ) ;
      
                              
                              try{
                                console.log(ret.hash);
                                alert('You can see this transaction in BSC Scan by the link below, https://bscscan.com/tx/'+ret.hash+'  ');

                                setTimeout(() => this.getStakeds(), 20000);
                                setTimeout(() => this.getTokenBalance(), 20000);
								
                              }catch (error){
                                console.log(error);
                                setTimeout(() => this.getStakeds(), 20000);
                                setTimeout(() => this.getTokenBalance(), 20000);
                                
                              }
                           
                              
                            });
                            
          }

            },beforeMount() {

                  if(window.ethereum){
                  // Do something 
                  //alert("Metamask extension OK!!")
                  }else{
                    alert("install metamask extension!!")
                  }

                  

                  window.ethereum.request({method:'eth_requestAccounts'})
                .then(res=>{
                        // Return the address of the wallet
                        console.log("Address:" + res) ;
                        this.userAddress = res;
                        this.getBalance(res);
                        //this.getTotalStaked();
                        this.getTokenBalance();
                        this.getStakeds();
                
                })
            }

                                      // <-
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 1.2rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}

.form__input {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 0.60rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 50%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}

.form__input_nft {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 0.95rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 54%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
  text-size-adjust: 50;
}

.form__input_text_big {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 50%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}

.form__input_text_big_2 {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 62%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}


.form__input:placeholder-shown + .form__label {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateY(-4rem);
  transform: translateY(-4rem);
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  font-size: 62,5%;
}


.div_box {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  border: 0.05rem;
  width: 80%;
  display: block;
  align-items: center;
  align-self: center;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}

.table{
  margin-left: auto;
  margin-right: auto;
  text-align:center ; 
  width:80%;

  
}



/* CSS */
.button-85 {
  padding: 0.6em 2em;
  border: none;
  outline: none;
  color: rgb(255, 255, 255);
  background: #111;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-85:before {
  content: "";
  background: linear-gradient(
    45deg,
    #ff0000,
    #ff7300,
    #fffb00,
    #48ff00,
    #00ffd5,
    #002bff,
    #7a00ff,
    #ff00c8,
    #ff0000
  );
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  -webkit-filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing-button-85 20s linear infinite;
  transition: opacity 0.3s ease-in-out;
  border-radius: 10px;
}


@keyframes glowing-button-85 {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.button-85:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #222;
  left: 0;
  top: 0;
  border-radius: 10px;
}




.styled-table {
    margin-left: auto;
    margin-right: auto;
    text-align:center ; 
    width:50%;
    border-collapse: collapse;
    font-size: 0.9em;
    font-family: sans-serif;
    min-width: 60%;
    box-shadow: 0 0 20px solid #3357cd;
}
.styled-table thead tr {
    background-color: #3357cd;
    color: #ffffff;
    text-align: left;
}
.styled-table th,
.styled-table td {
  white-space:pre;
    padding: 12px 15px;
}
.styled-table tbody tr {
    border-bottom: 2px solid #3357cd;
}

.styled-table tbody tr:nth-of-type(even) {
    background-color: #1E2025;
}

.styled-table tbody tr:last-of-type {
    border-bottom: 2px solid #3357cd;
}

.styled-table tbody tr.active-row {
    font-weight: bold;
    color: #3357cd;
}





</style>
